import { render, staticRenderFns } from "./setting-reviewScreenVersions.vue?vue&type=template&id=8219ebe8&scoped=true&"
import script from "./setting-reviewScreenVersions.vue?vue&type=script&lang=js&"
export * from "./setting-reviewScreenVersions.vue?vue&type=script&lang=js&"
import style0 from "./setting-reviewScreenVersions.vue?vue&type=style&index=0&id=8219ebe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8219ebe8",
  null
  
)

export default component.exports